var render = function render(_c,_vm){return _c(_vm.props.components.AxIcon,_vm._b({tag:"Component"},'Component',_vm.data,false),[_c('svg',{attrs:{"viewBox":"0 0 7 12"}},[_c('path',{attrs:{"fill":_vm.props.sorting === 'asc' ? '#686868' : '#c5c4c4',"d":"M3.182 0l3.182 5H0z"}}),_c('path',{attrs:{"fill":_vm.props.sorting === 'desc' ? '#686868' : '#c5c4c4',"d":"M3.182 12l3.182-5H0z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }